/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterHSmall = createReactComponent("outline", "letter-h-small", "IconLetterHSmall", [["path", { "d": "M10 16v-8", "key": "svg-0" }], ["path", { "d": "M14 8v8", "key": "svg-1" }], ["path", { "d": "M10 12h4", "key": "svg-2" }]]);

export { IconLetterHSmall as default };
//# sourceMappingURL=IconLetterHSmall.mjs.map
